import React, { useEffect, useState } from "react";
import {
  businessMatchingBusinessEntityPath,
  newBusinessMatchingOwnedBusinessEntityPath,
} from "../../../../routes";
import { Flash, Pagy } from "../../../shared/lib/types";
import Button from "../../shared/components/ui/Button";
import Background from "../../shared/components/ui/Background";
import { Box } from "../../shared/components/ui/chakra";
import Footer from "../../shared/components/app/Footer";
import PagyPagination from "../../shared/components/app/PagyPagination";
import RegistrationRequiredAction from "../../shared/components/app/RegistrationRequiredAction";
import Application from "../../shared/components/layouts/Application";
import { Options, SharedCurrentUser } from "../../shared/lib/types";
import BusinessEntityListItem from "./components/BusinessEntityListItem";
import { BusinessEntitySearchForm } from "./components/BusinessEntitySearchForm";
import RegistrationRequiredModal from "./components/RegistrationRequiredModal";
import { BusinessEntities, UseCaseSearch } from "./lib/types";
import BusinessMatchingHeader from "../shared/components/BusinessMatchingHeader";
import WandStarsIcon from "../../shared/components/icons/WandStarsIcon";

import { Container, Flex, Heading, Stack, Text } from "@chakra-ui/react";

const BusinessEntitiesIndex = ({
  flash,
  businessEntities,
  industries,
  prefectures,
  currentUser,
  pagy,
  businessFields,
  buildingTypes,
}: {
  flash: Flash;
  businessEntities: BusinessEntities;
  industries: Options;
  prefectures: Options;
  currentUser: SharedCurrentUser | null;
  pagy: Pagy;
  businessFields: Options;
  buildingTypes: Options;
}) => {
  const [useCase, setUseCase] = useState<UseCaseSearch>("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setUseCase((params.get("q[use_case_eq]") || "") as UseCaseSearch);
  }, []);

  useEffect(() => {
    sessionStorage.setItem("previousBusinessEntitiesIndexUrl", location.href);
  }, []);

  const showUseCase = useCase === "" ? "both" : useCase;

  return (
    <Application flash={flash} currentUser={currentUser}>
      <BusinessMatchingHeader currentUser={currentUser} />
      <Background color="brand.50">
        <Container maxW="container.lg">
          {!(
            currentUser?.has_any_business_entities ||
            currentUser?.is_readonly_user
          ) && (
            <Flex
              mt={{ base: 8, sm: 14 }}
              p={5}
              bgColor="brand.100"
              alignItems={{ base: "flex-start", sm: "center" }}
              gap={5}
            >
              <Box>
                <WandStarsIcon boxSize={10} color="primary" />
              </Box>
              <Flex
                flex={1}
                alignItems="inherit"
                direction={{ base: "column", sm: "row" }}
              >
                <Box flex={1}>
                  <Box
                    as="p"
                    fontWeight="bold"
                    wordBreak="keep-all"
                    __css={{
                      "& span": {
                        display: "inline-block",
                      },
                    }}
                  >
                    <Box as="span">受発注機能を利用して、</Box>
                    <Box as="span">
                      <Box as="span">ビジネスパートナーを</Box>
                      <Box as="span">見つけませんか？</Box>
                    </Box>
                  </Box>
                </Box>
                <Stack
                  gap={5}
                  alignItems="center"
                  w={{ base: "full", sm: "fit-content" }}
                >
                  <Button
                    as="a"
                    w="full"
                    href={newBusinessMatchingOwnedBusinessEntityPath()}
                  >
                    <Text pt={0.5}>受発注機能を利用開始する</Text>
                  </Button>
                </Stack>
              </Flex>
            </Flex>
          )}
          <Flex
            direction={{ base: "column", lg: "row" }}
            justify="space-between"
            alignItems={{ base: "start", lg: "center" }}
            mt={{ base: 8, sm: 14 }}
            mb={5}
          >
            <Heading size="lg">事業者検索</Heading>
          </Flex>

          <BusinessEntitySearchForm
            prefectures={prefectures}
            industries={industries}
            businessFields={businessFields}
            buildingTypes={buildingTypes}
            isDisabled={
              !(
                currentUser?.owned_business_entities?.current.is_active ||
                currentUser?.is_readonly_user
              )
            }
          />

          <Stack gap={4} mt={{ base: 6, md: 12 }}>
            {businessEntities.map((businessEntity) => (
              <RegistrationRequiredAction
                key={businessEntity.code}
                href={businessMatchingBusinessEntityPath(businessEntity.code)}
                currentUser={currentUser}
                renderModal={RegistrationRequiredModal}
                skipModalIf={() =>
                  (currentUser?.is_all_public_feature_accessible &&
                    currentUser.owned_business_entities?.current.is_active) ||
                  currentUser?.is_readonly_user
                }
                render={({ href, onClick }) => (
                  <Box
                    as="a"
                    key={businessEntity.code}
                    href={href}
                    onClick={onClick}
                  >
                    <BusinessEntityListItem
                      businessEntity={businessEntity}
                      showUseCase={showUseCase}
                    />
                  </Box>
                )}
              />
            ))}
          </Stack>
          <Flex justifyContent="center" mt={14}>
            <PagyPagination pagy={pagy} />
          </Flex>
        </Container>
      </Background>
      <Footer />
    </Application>
  );
};

export default BusinessEntitiesIndex;
